import { useParams } from 'react-router';
import { useGetConsentsAndDeclarationsQuery } from '../../../api/queries/getConsentsAndDeclarations';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import ConsentsAndDeclarationsInnerPage from './ConsentsAndDeclarationsInnerPage';

const ConsentsAndDeclarationsDetailsPage = () => {
    const { consentsAndDeclarationsId } = useParams<{ consentsAndDeclarationsId: string }>();

    const { data, loading } = useGetConsentsAndDeclarationsQuery({
        fetchPolicy: 'cache-and-network',
        variables: { id: consentsAndDeclarationsId },
    });

    const consentAndDeclaration = data?.consentsAndDeclarations;

    if (!consentAndDeclaration && loading) {
        return <LoadingElement />;
    }

    if (!consentAndDeclaration) {
        return <NotFoundResult />;
    }

    return <ConsentsAndDeclarationsInnerPage consentAndDeclaration={consentAndDeclaration} />;
};

export default ConsentsAndDeclarationsDetailsPage;
